import { render, staticRenderFns } from "./QuotationsNav.vue?vue&type=template&id=1b4e07b0&"
import script from "./QuotationsNav.vue?vue&type=script&lang=js&"
export * from "./QuotationsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports